module.exports = __webpack_public_path__ + "static/carrete_de_colector-51e1a13ac6cf1f8d4439ceacd4bed3ae.png";